import i18n from '@/i18n'
import moment from 'moment'

export function getLocale() {
  return navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language
}

export function getBrowserTz() {
  const offset = moment().format('ZZ')
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone

  return {
    offset,
    tz,
  }
}

export function getTzAbbr(tz) {
  tz = tz || getBrowserTz().tz

  // Since our vue i18n config doesn't change browser locale info,
  // we hard code it to id for now
  // const locale = getLocale()
  const locale = 'id'

  const tzAbbr = new Date()
    .toLocaleDateString(locale, {
      day: '2-digit',
      // timeZoneName: tz === 'Asia/Jakarta' ? 'shortGeneric' : 'long',
      timeZoneName: 'shortGeneric',
      timeZone: tz,
    })
    .slice(4)

  return tzAbbr
}

export function formatDateWithTz(input, format = 'DD MMM YYYY HH:mm', empty = '-', showTimezone = true) {
  if (!input) return empty

  // This value will be Asia/Jakarta, etc.
  const tz = getBrowserTz().tz
  const tzAbbr = getTzAbbr(tz)

  return moment(input).format(format) + (showTimezone ? ' ' + tzAbbr : '')
}

export function formatIndexDate(input, dateFormatOrOptions = {}, showTimezone = true) {
  // Get current locale from i18n
  const locale = i18n.locale || localStorage.getItem('language') || 'id'
  
  let dateFormat = 'DD MMM YYYY'
  let useTimezone = true

  // Check if second argument is an object (new style)
  if (typeof dateFormatOrOptions === 'object' && dateFormatOrOptions !== null) {
    dateFormat = dateFormatOrOptions.dateFormat || 'DD MMM YYYY'
    useTimezone = dateFormatOrOptions.showTimezone !== undefined ? dateFormatOrOptions.showTimezone : true
  } else {
    // Old style positional arguments
    dateFormat = dateFormatOrOptions || 'DD MMM YYYY'
    useTimezone = showTimezone
  }

  moment.locale(locale)

  const timeWithTz = formatDateWithTz(input, 'HH:mm', '-', useTimezone)
  const date = moment(input).format(dateFormat)

  return {
    date: date == 'Invalid date' ? '-' : date,
    time: timeWithTz == 'Invalid date' ? '-' : timeWithTz,
  }
}

export function parseISO8601Duration(isoDuration) {
  const regex =
    /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/
  const matches = isoDuration.match(regex)

  if (!matches) {
    return null
  }

  return {
    years: matches[1] ? parseInt(matches[1]) : null,
    months: matches[2] ? parseInt(matches[2]) : null,
    weeks: matches[3] ? parseInt(matches[3]) : null,
    days: matches[4] ? parseInt(matches[4]) : null,
    hours: matches[5] ? parseInt(matches[5]) : null,
    minutes: matches[6] ? parseInt(matches[6]) : null,
    seconds: matches[7] ? parseFloat(matches[7]) : null,
  }
}

export function isToday(dateString) {
  const today = moment().startOf('day')
  const date = moment(dateString).startOf('day')
  return date.isSame(today)
}

export function getDuration(startDate, endDate) {
  const start = new Date(startDate)
  const end = new Date(endDate)

  const options = { day: '2-digit', month: 'short', year: 'numeric' }
  const dateStr = start.toLocaleDateString('id-ID', options)

  const pad = (n) => String(n).padStart(2, '0')
  const startTime = `${pad(start.getHours())}:${pad(start.getMinutes())}`
  const endTime = formatDateWithTz(endDate, 'HH:mm')

  const diffMs = end - start
  const diffSec = Math.floor(diffMs / 1000)
  const hours = pad(Math.floor(diffSec / 3600))
  const minutes = pad(Math.floor((diffSec % 3600) / 60))
  const seconds = pad(diffSec % 60)

  const duration = `${hours}:${minutes}:${seconds}`
  const rangeStr = `${dateStr}, ${startTime} - ${endTime}`

  return { range: rangeStr, duration }
}

export function toUTC(dateStr) {
  return dateStr ? new Date(dateStr).toISOString() : null
}